import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["useRpcClient"];
import { wrapPromise } from 'persist-promise/wrapPromise';
import { getRulesRpc } from '../__generated__/chirp/com/hubspot/conditional/properties/rpc/ConditionalPropertiesUnifiedRpc';
import { stringify } from 'hub-http/helpers/params';
export function fetchConditionalPropertyRules(objectTypeId, rpcClient, query) {
  const _ref = query || {},
    rpcRequestOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
  return rpcClient.call(getRulesRpc, {
    request: {
      objectTypeId,
      requestOptions: Object.assign({
        pageSize: 100,
        includeActualConditionalPropertyRules: true
      }, rpcRequestOptions)
    }
  }).then(response => {
    const {
      results,
      offset: newOffset,
      hasMore
    } = response;
    if (hasMore) {
      return fetchConditionalPropertyRules(objectTypeId, rpcClient, Object.assign({}, query, {
        useRpcClient: true,
        offset: newOffset
      })).then(rules => results.concat(rules));
    }
    return results;
  });
}
export const makeConditionalPropertyRulesFetchKey = ({
  portalId,
  frameworkTypeIdentifier,
  query
}) => {
  const queryParams = stringify({
    includePipelineStageShim: query === null || query === void 0 ? void 0 : query.includePipelineStageShim
  });
  return `conditional-property-rules-${portalId || 'current'}-${frameworkTypeIdentifier}${queryParams && `?${queryParams}`}`;
};
export const conditionalPropertyRulesPersistedPromise = wrapPromise({
  namespace: 'FDSR',
  entityName: 'conditionalPropertyRules',
  deepFreeze: true,
  toCacheKey: makeConditionalPropertyRulesFetchKey,
  fetch: ({
    rpcClient,
    frameworkTypeIdentifier,
    query
  }) => fetchConditionalPropertyRules(frameworkTypeIdentifier, rpcClient, query)
});